<template>
  <div class="animated fadeIn">
    <!-- <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" /> -->
    <b-card>
      <template v-slot:header>
        <h5>Simulasi Pembayaran</h5>
      </template>

      <b-form @submit.prevent="calculateBayar">

        <b-row>
          <b-col md="6">
            <b-form-group label="No Faktur">
              <b-input-group >
                <b-form-input data-testid="inputNoFaktur" v-model="input.noFaktur" name="noFaktur" required></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Jenis Pembayaran">
              <b-form-select
                v-model="input.jenisPembayaran"
                name="gadaiKondisiKendaraan"
                data-testid="inputJenisPembayaran"
                :options="optJenisPembayaran"
                :disabled="optJenisPembayaran.length == 0"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled
                    >-- Please select an option --</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row v-if="input.jenisPembayaran == 'PP'">
          <b-col md="6" >
            <b-form-group label="Pokok">
              <b-input-group prepend="Rp.">
                <b-form-input v-model="input.pokok" name="pokok" required></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row> -->

        <div class="date-wrapper">
          <!-- <b-row>
            <b-col md="6">
              <label> Tanggal Gadai </label>
              <b-form-group>
                <b-form-input type="date" v-model="input.tanggalGadai" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <label> Tanggal Jatuh Tempo Sekarang </label>
              <b-form-group>
                <b-form-input type="date" v-model="input.tanggalJatuhTempoSekarang" />
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col md="6">
              <label> Tanggal Kedatangan </label>
              <b-form-group>
                <b-form-input data-testid="inputTanggalKedatangan" type="date" v-model="input.tanggalKedatangan" />
              </b-form-group>
            </b-col>
          </b-row>

        </div>
        <!-- <b-row>
          <b-col md="6">
            <b-form-group label="Jenis Pinjaman">
              <b-form-select
                v-model="input.jenisPinjaman"
                name="gadaiKondisiKendaraan"
                :options="optJenisPinjaman"
                :disabled="optJenisPinjaman.length == 0"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled
                    >-- Please select an option --</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- <div v-if="input.jenisPinjaman == 1">
          <b-row>
            <b-col md="6">
              <b-form-group label="Jenis Elektronik">
                <div class="d-flex">
                  <b-form-radio class="mr-3" v-model="input.isTV" value="true"
                    >TV</b-form-radio
                  >
                  <b-form-radio
                    v-model="input.isTV"
                    name="gadaiTipePinjamanElektronik"
                    value="false"
                    >Selain TV</b-form-radio
                  >
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="input.jenisPinjaman == 2">
          <div class="form-content-wrapper">
            <h6 class="form-title">DATA KENDARAAN</h6>
            <b-row>
              <b-col md="6">
                <b-form-group label="Tipe Pinjaman">
                  <div class="d-flex">
                    <b-form-radio class="mr-3" v-model="input.isBpkbOnly" value="true"
                      >BPKB Saja</b-form-radio
                    >
                    <b-form-radio
                      v-model="input.isBpkbOnly"
                      name="gadaiTipePinjamanElektronik"
                      value="false"
                      >Kendaraan + BPKB</b-form-radio
                    >
                  </div>
                </b-form-group>
              </b-col>
            </b-row> -->
            <!-- <b-row>
              <b-col md="6">
                <b-form-group label="Jenis Kendaraan">
                  <b-form-select
                    v-model="input.jenisKendaraan"
                    name="gadaiKondisiKendaraan"
                    :options="optKendaraanJenis"
                    :disabled="optKendaraanJenis.length == 0"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled
                        >-- Please select an option --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row> -->
          <!-- </div> -->
        <!-- </div> -->
        <div class="form-wrapper-btn">
          <b-button
          data-testid="simulasiHitungElektronikBtn"
            type="submit"
            name="simulasiHitungElektronikBtn"
            variant="pgiBtn"
            :disabled="isSubmitting"
          >
            <i class="fa fa-calculator mr-2"></i>
            {{ isSubmitting ? "Menghitung..." : "Hitung" }}
          </b-button>
        </div>
      </b-form>
    </b-card>

    <b-modal id="modal-data-pembayaran" title="Pembayaran" @hidden="resetInput" ok-only
>
      <div v-if="dataHitungPembayaran.length != 0">
        <div class="detail-data-wrapper mb-3">
          <h6 class="form-title">
            RINCIAN PEMBAYARAN - <span v-if="input.jenisPembayaran === 'PL'">PELUNASAN</span
            ><span v-else>PERPANJANGAN</span>
          </h6>
          <template v-if="dataHitungPembayaran.inquiryGadaiAngsuran">
            <b-table bordered small responsive class="rincian-angsuran-table mb-0"
                :items="dataHitungPembayaran.inquiryGadaiAngsuran.jadwalAngsuran" :fields="jadwalAngsuranFields">
                <template v-slot:cell(tenorKe)="row">
                    <div class="text-center">{{ row.item.tenorKe }}</div>
                </template>
                <template v-slot:cell(periode)="row">
                    {{ $helper.changeDateFormat(row.item.periode) }}
                </template>
                <template v-slot:cell(jasa)="row">
                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.jasa) }}</div>
                </template>
                <template v-slot:cell(admin)="row">
                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.admin) }}</div>
                </template>
                <template v-slot:cell(angsuran)="row">
                    <div class="text-right no-wrap"><strong>Rp. {{ $helper.addThousandSeparator(row.item.angsuran) }}</strong></div>
                </template>
            </b-table>
            <div class="rincian-angsuran-summary">
                <div class="d-flex justify-content-between">
                    <span>Denda</span>
                    <span>Rp. {{ $helper.addThousandSeparator(dataHitungPembayaran.inquiryGadaiAngsuran.denda) }}</span>
                </div>
                <div class="d-flex justify-content-between rincian-angsuran-total">
                    <strong>Total</strong>
                    <strong>Rp. {{ $helper.addThousandSeparator(dataHitungPembayaran.total) }}</strong>
                </div>
            </div>
          </template>
          <template v-else>
            <ul class="list-pembayaran-wrapper">
              <li v-for="(item, idx) in dataHitungPembayaran.items" v-bind:key="idx">
                <p class="mb-0">{{ item.name }}</p>
                <p v-if="item.nominal == null">
                  {{ $helper.addThousandSeparator(item.nominal) }}
                </p>
                <p v-else>Rp. {{ $helper.addThousandSeparator(item.nominal) }}</p>
              </li>
            </ul>
            <ul
              v-if="
                input.bayarBulanBerikutnya == true &&
                dataHitungPembayaran.jasaBulanBerikutnya != null
              "
              class="list-pembayaran-wrapper"
            >
              <li>
                <p class="mb-0">{{ dataHitungPembayaran.jasaBulanBerikutnya.name }}</p>
                <p v-if="dataHitungPembayaran.jasaBulanBerikutnya.nominal == null">
                  {{
                    $helper.addThousandSeparator(
                      dataHitungPembayaran.jasaBulanBerikutnya.nominal
                    )
                  }}
                </p>
                <p v-else>
                  Rp.
                  {{
                    $helper.addThousandSeparator(
                      dataHitungPembayaran.jasaBulanBerikutnya.nominal
                    )
                  }}
                </p>
              </li>
            </ul>
            <ul
              v-if="
                input.bayarBulanBerikutnya == true &&
                dataHitungPembayaran.adminFeeBulanBerikutnya != null
              "
              class="list-pembayaran-wrapper"
            >
              <li>
                <p class="mb-0">{{ dataHitungPembayaran.adminFeeBulanBerikutnya.name }}</p>
                <p v-if="dataHitungPembayaran.adminFeeBulanBerikutnya.nominal == null">
                  {{
                    $helper.addThousandSeparator(
                      dataHitungPembayaran.adminFeeBulanBerikutnya.nominal
                    )
                  }}
                </p>
                <p v-else>
                  Rp.
                  {{
                    $helper.addThousandSeparator(
                      dataHitungPembayaran.adminFeeBulanBerikutnya.nominal
                    )
                  }}
                </p>
              </li>
            </ul>
            <ul
              v-if="dataHitungPembayaran.angsuranPokok != 0"
              class="list-pembayaran-wrapper"
            >
              <li>
                <p class="mb-0">Angsuran Pokok</p>
                <p>Rp. {{ $helper.addThousandSeparator(dataHitungPembayaran.angsuranPokok) }}</p>
              </li>
            </ul>
            <div class="pl-4" v-if="dataHitungPembayaran.jatuhTempo2BulanBerikutnya == null || input.bayarBulanBerikutnya == false">
              <p class="mb-0">
                Total :
                <strong
                  >Rp.
                  {{ $helper.addThousandSeparator(dataHitungPembayaran.total) }}</strong
                >
              </p>
              <p class="mb-0 smallText text-muted">
                Jatuh Tempo Selanjutnya :
                {{ $helper.changeDateFormat(dataHitungPembayaran.jatuhTempoSelanjutnya) }}
              </p>
            </div>
            <div class="pl-4" v-else>
              <p class="mb-0" v-if="dataHitungPembayaran.angsuranPokok != 0">
                Angsuran Pokok :
                <strong
                  >Rp.
                  {{ $helper.addThousandSeparator(dataHitungPembayaran.angsuranPokok) }}</strong
                >
              </p>
              <p class="mb-0">
                Total :
                <strong
                  >Rp.
                  {{ $helper.addThousandSeparator(dataHitungPembayaran.total) }}</strong
                >
              </p>
              <p class="mb-0 smallText text-muted">
                Jatuh Tempo Selanjutnya :
                {{
                  $helper.changeDateFormat(dataHitungPembayaran.jatuhTempo2BulanBerikutnya)
                }}
              </p>
            </div>
          </template>
        </div>
      </div>
      <template v-if="!dataHitungPembayaran.inquiryGadaiAngsuran">
        <b-row v-if="input.jenisPembayaran === 'PP' && dataHitungPembayaran.jasaBulanBerikutnya != null">
          <b-col md="6">
            <b-form-group>
              <b-form-checkbox data-testid="CheckboxBayarBulanBerikutnya" v-model="input.bayarBulanBerikutnya">
                Bayar Bulan Berikutnya
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "simulasi-pembayaran",

  data() {
    return {
      role: null,
      initStatus: 0,
      isSubmitting: false,

      jenisPinjaman: 0,
      dataHitungPembayaran: [],
      input: {
        tanggalGadai: "",
        tanggalJatuhTempoSekarang: "",
        tanggalKedatangan: "",
        jenisPembayaran: "",
        pokok: 0,
        noFaktur:"",
        jenisPinjaman: 1,
        isBpkbOnly: false,
        isTV: false,
        keringananId: 1,
        jenisKendaraan: "",
        lelangStatus: 0,
        hasEntryInLelang: false,
        skema: 2,
        forInquiry: false,
        // tipePelunasan : null,
        bayarBulanBerikutnya: false
      },

      optJenisPembayaran: [
        { value: "PP", text: "Perpanjangan" },
        { value: "PL", text: "Pelunasan" },
      ],

      jadwalAngsuranFields: [
        { key: "tenorKe", label: "Angsuran Ke-" },
        { key: "periode", label: "Periode" },
        { key: "jasa", label: "Jasa" },
        { key: "admin", label: "Admin" },
        { key: "angsuran", label: "Angsuran" },
      ],

      optJenisPinjaman: [
        { value: "1", text: "Elektronik" },
        { value: "2", text: "BPKB Kendaraan" },
        { value: "3", text: "Emas" },
      ],

      optKendaraanJenis: [],
    };
  },
  watch: {
  "input.pokok": function (newValue) {
    if (newValue !== "") {
      let cleanValue = this.$helper.changeToValue(newValue);

      // Hapus angka 0 di depan, kecuali jika hanya "0"
      cleanValue = cleanValue.replace(/^0+(?=\d)/, "");

      // Format angka dengan titik pemisah ribuan
      const result = cleanValue
        .replace(/(?!^-)[^0-9]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      this.$nextTick(() => (this.input.pokok = result));
    }
  },
    "input.bayarBulanBerikutnya": function() {
      this.calculateBayar();
    },
},
  methods: {
    init() {
      this.initStatus = 0;
      this.$axios
        .get("barang-jenis/kendaraan")
        .then((response) => {
          this.optKendaraanJenis = response.data.map((item) => {
            return { value: item.id, text: item.name };
          });
        });
    },
    calculateBayar() {
      // Do calculation
      const params = new URLSearchParams({
        jenisPembayaran: this.input.jenisPembayaran,
        // angsuranPokok: this.$helper.removeThousandSeparator(this.input.pokok),
        // tanggalGadai: this.input.tanggalGadai,
        // tanggalJatuhTempoSekarang: this.input.tanggalJatuhTempoSekarang,
        // tanggalJatuhTempoSebelum: this.input.tanggalJatuhTempoSebelum,
        noFaktur: this.input.noFaktur,
        tanggalKedatangan: this.input.tanggalKedatangan,
        cabangPembayaranId : this.$helper.getCabangId(),
        // tipePelunasan:1,
        bayarBulanBerikutnya: this.input.bayarBulanBerikutnya,
        // jenisPinjaman: this.input.jenisPinjaman,
        // skema: this.input.skema,
        // forInquiry: this.input.forInquiry,
        // isTV: this.input.isTV,
        // isBpkbOnly: this.input.isBpkbOnly,
        // keringananId: this.input.keringananId,
        // jenisKendaraan: this.input.jenisKendaraan,
        // lelangStatus: this.input.lelangStatus,
        // hasEntryInLelang: this.input.hasEntryInLelang,
      });
      // if(this.input.tipePembayaran == "PL"){
      //   params.append("tipePelunasan", this.input.tipePelunasan)
      // }
      


    //   else{
    //     params.append("angsuranPokok", this.$helper.removeThousandSeparator(this.input.pokok))
    //   }
      this.isSubmitting = true;
      this.$axios
        .get(`gadai-pembayaran/simulasi-pembayaran?${params.toString()}`)
        .then((response) => {
          this.dataHitungPembayaran = response.data;
          
          this.$bvModal.show("modal-data-pembayaran");
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    resetInput() {
      this.input = {
        tanggalGadai: "",
        tanggalJatuhTempoSekarang: "",
        tanggalKedatangan: "",
        jenisPembayaran: "",
        pokok: 0,
        noFaktur: "",
        jenisPinjaman: 1,
        isBpkbOnly: false,
        isTV: false,
        keringananId: 1,
        jenisKendaraan: "",
        lelangStatus: 0,
        hasEntryInLelang: false,
        skema: 2,
        forInquiry: false,
        tipePelunasan: null,
        bayarBulanBerikutnya: false
      };

      this.dataHitungPembayaran = []; // kalau mau sekalian reset hasil hitungan
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
.rincian-angsuran-table th {
  vertical-align: middle;
  font-size: 13px;
}

.rincian-angsuran-table td {
  vertical-align: middle;
  font-size: 13px;
}

.rincian-angsuran-summary {
  margin-top: 8px;
}

.rincian-angsuran-summary .rincian-angsuran-total {
  margin-top: 4px;
}
</style>